import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  aboutMe: null,
  loading: false,
  error: false,
};

const getAboutMeRequest = createAction("getAboutMeRequest");
const getAboutMeSuccess = createAction("getAboutMeSuccess");
const getAboutMeFailure = createAction("getAboutMeFailure");

export const aboutMeReducer = createReducer(initialState, (builder) => {
  builder
    // Get About Me
    .addCase(getAboutMeRequest, (state) => {
      state.loading = true;
    })
    .addCase(getAboutMeSuccess, (state, action) => {
      state.loading = false;
      state.aboutMe = action.payload;
    })
    .addCase(getAboutMeFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
